<template>
  <div class="box" @click="openDetail">
    <div class="left-box">
      <van-image
        width="90px"
        height="120px"
        class="right-img"
        :src="item.userHeadImg"
        fit="cover"
      />
      <slot></slot>
    </div>
    <div class="right-but">
      <div class="info-table">
        <div class="info-item">
          <div class="info-name">值班人：</div>
          <div class="info-value">{{ item.userName }}</div>
        </div>
        <div class="info-item">
          <div class="info-name">值班主题：</div>
          <div class="info-value">{{ item.title }}</div>
        </div>
        <div class="info-item">
          <div class="info-name">界别：</div>
          <div class="info-value">{{ item.deleName || '-' }}</div>
        </div>
        <div class="info-item">
          <div class="info-name">单位及职务：</div>
          <div class="info-value">{{ item.position || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
import { Image as VanImage } from 'vant';
export default {
  name: 'OnDutyToday',
  components: {
    [VanImage.name]: VanImage
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup (props) {
    const router = useRouter()
    const openDetail = () => {
      router.push({ path: '/detail', query: { id: props.item.id } })
    }
    return {
      openDetail
    }
  }
}
</script>
<style lang="less" scoped>
.box {
  box-sizing: border-box;
  background-color: #f0f7fc;
  padding: 20px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  .left-box {
  }
  .right-img {
    flex-shrink: 0;
  }
  .info-item {
    display: flex;
    margin-bottom: 8px;
    .info-name {
      font-family: PingFang SC;
      font-size: 16px;
      color: #666666;
      width: 100px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
    }
    .info-value {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #121212;
      line-height: 29px;
    }
  }
  .right-but {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-left: 14px;
    flex-grow: 1;
    .on-duty {
      width: 142px;
      height: 48px;
      background: #0f5293;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 17px;
      color: #ffffff;
      line-height: 48px;
      text-align: center;
      margin-bottom: 14px;
      cursor: pointer;
    }
    .add-message {
      width: 142px;
      height: 48px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 17px;
      color: #0f5293;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #0f5293;
      cursor: pointer;
    }
  }
}
</style>